import ChatFailureType from "@mapmycustomers/shared/enum/chat/ChatFailureType";
import { isApiError } from "@mapmycustomers/shared/util/assert";

const STATUS_FAILURES: Record<number, ChatFailureType> = {
  400: ChatFailureType.VALIDATION,
  404: ChatFailureType.CONVERSATION_GONE,
  409: ChatFailureType.BUSY,
  502: ChatFailureType.UNAVAILABLE,
};

// An ApiError without a status never reached the server, which is the same situation for the
// rep as no connection at all — both are retryable, so both read as NETWORK.
const getChatFailureType = (error: unknown): ChatFailureType => {
  if (!isApiError(error) || error.status === undefined) {
    return ChatFailureType.NETWORK;
  }
  return STATUS_FAILURES[error.status] ?? ChatFailureType.UNKNOWN;
};

export default getChatFailureType;
